import { createContext } from "react";

const verticle_nav = createContext(null);
const userContext = createContext(null);

export { userContext, verticle_nav };
